const SELECTORS = {
    block: '.wp-block-ssm-team-members',
    nav: '.nav-wrapper',
    navButton: '.nav-button',
    section: '[data-section]',
};

const CLASSES = {
    active: 'is-active',
};

export const TeamMembersNav = () => {
    document.querySelectorAll(SELECTORS.block).forEach((block) => {
        initTeamMembersNav(block);
    });
};

export const initTeamMembersNav = (block, isEditor = false) => {
    const nav = block.querySelector(SELECTORS.nav);
    if (!nav) return;

    const navButtons = [...nav.querySelectorAll(SELECTORS.navButton)];
    const sections = [...block.querySelectorAll(SELECTORS.section)];

    if (!navButtons.length || !sections.length) return;

    const queryDoc = isEditor ? block.ownerDocument : document;
    const queryWin = isEditor ? block.ownerDocument.defaultView : window;

    let isScrollingFromClick = false;
    let scrollEndTimer = null;

    const getHeaderOffset = () => parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0', 10);

    // --- Smooth scroll on click ---
    navButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();

            const target = btn.getAttribute('href');
            if (!target?.startsWith('#')) return;

            const panel = queryDoc.querySelector(target);
            if (!panel) return;

            const headerHeight = isEditor ? 0 : getHeaderOffset();
            const top = panel.getBoundingClientRect().top + queryWin.scrollY - headerHeight;

            isScrollingFromClick = true;
            clearTimeout(scrollEndTimer);

            setActive(navButtons, btn);
            queryWin.scrollTo({ top, behavior: 'smooth' });

            const checkScrollEnd = () => {
                clearTimeout(scrollEndTimer);
                scrollEndTimer = setTimeout(() => {
                    isScrollingFromClick = false;
                    queryWin.removeEventListener('scroll', checkScrollEnd);
                }, 150);
            };

            queryWin.addEventListener('scroll', checkScrollEnd, { passive: true });

            setTimeout(() => {
                isScrollingFromClick = false;
                queryWin.removeEventListener('scroll', checkScrollEnd);
            }, 2000);
        });
    });

    // --- Scrollspy via IntersectionObserver ---
    let observer;

    const buildObserver = () => {
        if (observer) observer.disconnect();

        const offset = isEditor ? 0 : getHeaderOffset();
        const rootMargin = `-${offset}px 0px -50% 0px`;

        observer = new IntersectionObserver(
            (entries) => {
                if (isScrollingFromClick) return;

                const intersecting = entries.filter((e) => e.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

                if (!intersecting.length) return;

                const id = intersecting[0].target.dataset.section;
                const active = navButtons.find((btn) => btn.dataset.target === id);
                if (active) setActive(navButtons, active);
            },
            { rootMargin },
        );

        sections.forEach((s) => observer.observe(s));
    };

    buildObserver();

    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(buildObserver, 200);
    });

    let resizeTimer;

    // --- Initial active state ---
    const initActive = () => {
        const hash = window.location.hash;
        if (hash) {
            const matched = navButtons.find((btn) => btn.getAttribute('href') === hash);
            if (matched) {
                setActive(navButtons, matched);

                return;
            }
        }
        if (navButtons[0]) setActive(navButtons, navButtons[0]);
    };

    initActive();
};

const setActive = (buttons, active) => {
    buttons.forEach((btn) => btn.classList.toggle(CLASSES.active, btn === active));
};
